export const pagename = {
  'course-center': '选课中心页',
  'course-detail': '课程详情页',
  search: '搜索页',
  downLoad: '客户端下载页',
  article: '文章页',
  'add-purchase': '换购页',
  'teacher-info': '老师页',
  feedback: '反馈页'
}



// WEBPACK FOOTER //
// ./src/defines/pagename.js